@if (!initialized && loading) {
  <div class="init-loader">
    @if (loading) {
      <mat-spinner class="spinner" color="accent" mode="indeterminate"></mat-spinner>
    }
  </div>
}
@if (initialized && loading) {
  <div class="component-loader-bar">
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
}

@if (initialized) {
  <div>
    @if (isSingleReport && dailyReport) {
      <div class="rows">
        <!-- Daily Report status -->
        <ng-container *ngTemplateOutlet="dailyReportLastStatus"></ng-container>
        <!-- /Daily Report status -->
        <div class="row">
          <mat-form-field>
            <mat-label>
              @if (dailyReport.work_condition_code > 999) {
                Non workday
              }
              @if (!(dailyReport.work_condition_code > 999)) {
                Workday
              }
            </mat-label>
            <mat-select [compareWith]="softCompare" [disabled]="!editable" [(value)]="dailyReport.work_condition_code">
              <mat-option value="999">Workday</mat-option>
              <mat-optgroup label="Non-workday">
                @for (wc of workConditions; track wc) {
                  <mat-option [value]="wc.code">
                    {{wc.text}}
                  </mat-option>
                }
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
          <div class="icon">
            @if (editable) {
              <button mat-stroked-button
                color="primary"
                (click)="saveDailyReport()"
                >
                @if (dailyReport.id) {
                  Save
                }
                @if (!dailyReport.id) {
                  Create
                }
              </button>
            }
          </div>
        </div>
        @if (dailyReport.work_condition_code == 1004 && editable) {
          <div>
            <mat-form-field>
              <mat-label>Add a short note</mat-label>
              <textarea matInput [(ngModel)]="dailyReport.work_condition_comment"></textarea>
            </mat-form-field>
          </div>
        }
      </div>
    }
    <mat-accordion class="consolidated-report" multi>
      <!-- Weather -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          @if (summary.weather) {
            <app-icon icon="weather/{{summary.weather.getIcon}}.png"></app-icon>
          }
          @if (!summary.weather) {
            <app-icon icon="weather/116.png"></app-icon>
          }
          <div>
            <div class="mat-subtitle-1">Weather</div>
            <div class="mat-body">
              @if (summary.weather) {
                {{summary?.weather?.avgtemp}}°F {{summary.weather?.condition?.text}}
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <!-- weather content -->
        <ng-container class="rows">
          @for (site of sites; track site) {
            @if (weathers | filter: 'site_id': site.id; as l) {
              @for (weather of l; track weather) {
                <!-- Weather not available -->
                @if (weather.isEmpty) {
                  <div class="mat-body-strong">
                    Weather not added
                    <button mat-mini-fab title="Add weather" (click)="openReportWeather(weather)"
                      [disabled]="!weather.editable">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                }
                <!-- Weather not available -->
                @if (!weather.isEmpty) {
                  <div class="cards-container" >
                    <div class="line-items">
                      <div  class="mat-body-2">
                        SITE {{site.name}}
                      </div>
                      <app-report-weather-card class="card" [weather]="weather"
                        (click)="openReportWeather(weather)">
                      </app-report-weather-card>
                    </div>
                  </div>
                }
              }
            }
          }
        </ng-container>
        <!-- /weather content -->
      </mat-expansion-panel>
      <!-- /Weather -->
      <!-- bid items -->
      <mat-expansion-panel [disabled]="!reportBidItems.length">
        <mat-expansion-panel-header>
          <div class="expansion-header">
            <div class="expansion-header-left-panel">
              <app-icon icon="bid-item.png"></app-icon>
              <div class="panel-header-body">
                <div class="mat-subtitle-1">Bid items</div>
                @if (reportBidItems.length) {
                  <div class="mat-body"
                    >
                    {{ rbiCaption?.biditems }} {rbiCaption?.biditems, plural, =1 {item} other {items}}
                  </div>
                }
              </div>
            </div>
            <div class="expansion-header-right-panel">
              @if (editable && dailyReport?.id) {
                <div class="panel-header-actions"
                  >
                  <button mat-icon-button
                    (click)="openReportBidItem($event, dailyReport)">
                    <mat-icon class="add-icon"
                      inline="true"
                      title="Add New">add
                    </mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <!-- bid items content -->
        @if (reportBidItems.length) {
          <app-rbi-summary
            [project]="project"
            [rbis]="reportBidItems"
            [drs]="dailyReports"
            [projectConsolidatedReport]="showConsolidatedReport"
            (summaryCaption)="updateValue($event, 'rbiCaption')"
            (changed)="onRbiChange($event)">
          </app-rbi-summary>
        }
        <!-- /bid items content -->
      </mat-expansion-panel>
      <!-- /bid items -->
      <!-- material deliveries -->
      <mat-expansion-panel [disabled]="!rmds?.length">
        <mat-expansion-panel-header>
          <div class="expansion-header">
            <div class="expansion-header-left-panel">
              <app-icon icon="delivery.png"></app-icon>
              <div class="panel-header-body">
                <div class="mat-subtitle-1">Material deliveries</div>
                @if (rmdCaption && rmds?.length) {
                  <div class="mat-body"
                    >
                    @if (rmdCaption.delivery) {
                      {{ rmdCaption.delivery }}
                      delivery
                    }
                    @if (rmdCaption.delivery && rmdCaption.usage) {
                      &amp;
                    }
                    @if (rmdCaption.usage) {
                      {{ rmdCaption.usage }}
                      usage
                    }
                    {rmdCaption.total, plural, =0 {None} =1 {item} other {items}}
                  </div>
                }
              </div>
            </div>
            <div class="expansion-header-right-panel">
              @if (editable && dailyReport?.id) {
                <div class="panel-header-actions"
                  >
                  <button mat-icon-button
                    [matMenuTriggerFor]="menuMaterialDeliveries"
                    (click)="$event.stopPropagation()">
                    <mat-icon class="add-icon"
                      inline="true"
                      title="Add New">add
                    </mat-icon>
                  </button>
                  <mat-menu #menuMaterialDeliveries="matMenu">
                    <button mat-menu-item
                      (click)="openRMD($event, 'delivery')">Add delivery
                    </button>
                    <button mat-menu-item
                      (click)="openRMD($event, 'usage')">Add usage
                    </button>
                  </mat-menu>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <!-- material deliveries content -->
        @if (rmds?.length) {
          <app-rmd-summary
            (summaryCaption)="updateValue($event, 'rmdCaption')"
            (changed)="onRmdChange($event)"
            [drs]="dailyReports"
            [project]="project"
            [rmds]="rmds">
          </app-rmd-summary>
        }
        <!-- /material deliveries content -->
      </mat-expansion-panel>
      <!-- /material deliveries -->
      <!-- material-tests -->
      <mat-expansion-panel [disabled]="!smts.length && !rits?.length">
        <mat-expansion-panel-header>
          <div class="expansion-header">
            <div class="expansion-header-left-panel">
              <app-icon icon="lab.png"></app-icon>
              <div class="panel-header-body">
                <div class="mat-subtitle-1">Material Tests</div>
                <div class="mat-body">
                  @if (smts.length) {
                    @if (smts | filter: 'status': ['passed', 'failed', 'cancelled']: 'not in'; as l) {
                      @if (l.length) {
                        {{ l.length }} open
                      }
                    }
                    @if (smts | filter: 'status': ['passed', 'failed', 'cancelled']: 'in'; as l) {
                      @if (l.length) {
                        {{ l.length }} closed
                      }
                    }
                  }
                  @if (internalTests?.length) {
                    {{ internalTests.length }} onsite
                  }
                </div>
              </div>
            </div>
            <div class="expansion-header-right-panel">
              @if (editable && dailyReport?.id) {
                <div class="panel-header-actions"
                  >
                  <button mat-icon-button
                    [matMenuTriggerFor]="menuMaterialTests"
                    (click)="$event.stopPropagation()">
                    <mat-icon class="add-icon"
                      inline="true"
                      title="Add New">add
                    </mat-icon>
                  </button>
                  <mat-menu #menuMaterialTests="matMenu">
                    <button mat-menu-item
                      (click)="addLineItem($event, 'SiteMaterialTest')">Add
                      offsite test
                    </button>
                    <button mat-menu-item
                      (click)="openRIT($event)">Add onsite test
                    </button>
                  </mat-menu>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <mat-tab-group>
          <mat-tab label="Offsite">
            <ng-container matTabContent *ngTemplateOutlet="smtContent"></ng-container>
          </mat-tab>
          <mat-tab label="Onsite">
            @if (!rits.length) {
              <div class="mat-body-2 tab-content">
                No onsite tests are added
              </div>
            }
            @if (rits.length) {
              <app-rit-summary
                (changed)="onRitChange($event)"
                [project]="project"
                [drs]="dailyReports"
              [rits]="rits"></app-rit-summary>
            }
          </mat-tab>
        </mat-tab-group>
      </mat-expansion-panel>
      <!-- / material-tests -->
      <!-- issues -->
      <mat-expansion-panel [disabled]="!reportIssues.length">
        <mat-expansion-panel-header>
          <div class="expansion-header">
            <div class="expansion-header-left-panel">
              <app-icon icon="issue.png"></app-icon>
              <div class="panel-header-body">
                <div class="mat-subtitle-1">Issues</div>
                @if (reportIssues.length) {
                  <div class="mat-body">
                    {{reportIssues.length}} {reportIssues.length, plural, =1 {issue} other {issues}}
                  </div>
                }
              </div>
            </div>
            <div class="expansion-header-right-panel">
              @if (editable && dailyReport?.id) {
                <div class="panel-header-actions">
                  <button mat-icon-button (click)="addLineItem($event, 'Issue')">
                    <mat-icon class="add-icon" inline="true" title="Add New">add</mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <ng-container *ngTemplateOutlet="issuesContent"></ng-container>
      </mat-expansion-panel>
      <!-- /issues -->
      <!-- labor equipment -->
      <mat-expansion-panel [disabled]="!reportLabors.length && !reportEquipments.length">
        <mat-expansion-panel-header>
          <div class="expansion-header">
            <div class="expansion-header-left-panel">
              <app-icon icon="labor.png"></app-icon>
              <div class="panel-header-body">
                <div class="mat-subtitle-1">Labor &amp; Equipment</div>
                @if (reportLabors.length) {
                  <div class="mat-body">
                    Labor: {{reportLabors.length}}
                    Equipment: {{reportEquipments.length}}
                  </div>
                }
              </div>
            </div>
            <div class="expansion-header-right-panel">
              @if (editable && dailyReport?.id) {
                <div class="panel-header-actions">
                  <button mat-icon-button [matMenuTriggerFor]="menuLaborEquipmentAdd">
                    <mat-icon class="add-icon" inline="true" title="Add New">add</mat-icon>
                  </button>
                  <mat-menu #menuLaborEquipmentAdd="matMenu">
                    <button mat-menu-item (click)="addLineItem($event, 'ReportLabor')">Add Labor</button>
                    <button mat-menu-item (click)="addLineItem($event, 'ReportEquipment')">Add Equipment</button>
                  </mat-menu>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <ng-container *ngTemplateOutlet="laborContent"></ng-container>
      </mat-expansion-panel>
      <!-- /labor equipment -->
      <!-- activities -->
      <mat-expansion-panel [disabled]="!reportActivities.length">
        <mat-expansion-panel-header (click)="openReportActivity($event)">
          <app-icon icon="activity.png"></app-icon>
          <div class="panel-header-body">
            <div class="mat-subtitle-1">Activities</div>
            <div class="mat-body">
              @if (reportActivities.length) {
                {{reportActivities.length}} {reportActivities.length, plural, =1 {item} other {items}}
              }
              @if (!reportActivities.length) {
                None
              }
            </div>
          </div>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <!-- /activities -->
    </mat-accordion>
  </div>
}

<!-- issues content -->
<ng-template #issuesContent>
  <div class="rows">

    @if (isSingleReport) {
      @for (site of sites; track site) {
        @if (reportIssues | filter: 'entity_type': 'site' | filter: 'entity_id': site.id; as issues) {
          @if (issues.length) {
            <app-report-issues
              (bubbleClick)="openIssue($event)"
              [issues]="issues"
              [date]="reportDate" [project]="project"
              [site]="site">
            </app-report-issues>
          }
        }
      }
    }

    <!-- Site issues -->
    @if (!isSingleReport) {
      <mat-accordion>
        @for (site of sites; track site) {
          <div>
            @if (reportIssues | filter: 'entity_type': 'site' | filter: 'entity_id': site.id; as issues) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  SITE {{site.name}} ({{issues.length}} issues)
                </mat-expansion-panel-header>
                <app-report-issues (bubbleClick)="openIssue($event)" [issues]="issues" [date]="reportDate"
                  [project]="project" [site]="site">
                </app-report-issues>
              </mat-expansion-panel>
            }
          </div>
        }
      </mat-accordion>
    }
    <!-- /Site issues -->

  </div>
</ng-template>
<!-- / issues content -->

<!-- smt content -->
<ng-template #smtContent>
  <div class="rows">
    <!-- Open tests -->
    <div>
      @if (smts | filter: 'status': ['passed', 'failed', 'cancelled']: 'not in'; as l) {
        @if (l.length) {
          <div class="section-title">Open</div>
        }
        <div class="cards-container">
          @for (smt of l; track smt) {
            <div class="card link">
              <app-site-material-test-short (click)="openSmt(smt)" [smt]="smt">
              </app-site-material-test-short>
            </div>
          }
        </div>
      }
    </div>
    <!-- /Open tests -->

    <!-- Closed tests -->
    <div>
      @if (smts | filter: 'status': ['passed', 'failed', 'cancelled']: 'in'; as l) {
        @if (l.length) {
          <div class="section-title">Closed</div>
        }
        <div class="cards-container">
          @for (smt of l; track smt) {
            <div class="card link">
              <app-site-material-test-short (click)="openSmt(smt)" [smt]="smt">
              </app-site-material-test-short>
            </div>
          }
        </div>
      }
    </div>
    <!-- /Closed tests -->
  </div>
</ng-template>
<!-- / smt content -->

<!-- labor equipment content -->
<ng-template #laborContent>
  <div class="rows">
    @for (site of sites; track site) {
      <div>
        @if (!isSingleReport) {
          <div class="mat-body-2">SITE {{site.name}}</div>
        }
        <div class="cards-container">
          <div class="card">
            <div class="rows">
              <section>
                <!-- Labor list -->
                <div class="section-title">Labor:</div>
                @if (reportLabors | filter: 'site_id': site.id; as lineItems) {
                  @if (!lineItems.length) {
                    <div>No records</div>
                  }
                  @for (li of lineItems; track li) {
                    <div class="ruler-card">
                      <app-report-labor-card class="link" (click)="openReportLabor(li)" [reportLabor]="li">
                      </app-report-labor-card>
                    </div>
                  }
                }
                <!-- /Labor list -->
              </section>
              <section>
                <!-- Equipment list -->
                <div class="section-title">Equipment:</div>
                @if (reportEquipments | filter: 'site_id': site.id; as lineItems) {
                  @if (!lineItems.length) {
                    <div>No records</div>
                  }
                  @for (li of lineItems; track li) {
                    <div class="ruler-card">
                      <app-report-equipment-card class="link" (click)="openReportEquipment(li)" [reportEquipment]="li">
                      </app-report-equipment-card>
                    </div>
                  }
                }
                <!-- /Equipment list -->
              </section>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>
<!-- /labor equipment content -->

<ng-template #dailyReportLastStatus>

  @if (!dailyReport.lastApprovalAction && dailyReport.status == 'draft') {
    <div>
      Draft by {{dailyReport.createdBy?.name}}
      <span class="mat-caption">on {{dailyReport.created_at | dateFormat: 'very-long'}}</span>
    </div>
  }
  @if (dailyReport.lastApprovalAction?.id) {
    <div>
      {{dailyReport.lastApprovalAction?.state?.comment}} by {{dailyReport.lastApprovalAction?.actor?.name}}
      <span class="mat-caption">on {{dailyReport.lastApprovalAction?.created_at | dateFormat: 'very-long'}}</span>
    </div>
  }

</ng-template>
